"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useThemeCssVars = useThemeCssVars;
var _react = require("react");
var _ThemeContext = require("./ThemeContext");
/**
 * @returns {Object} An object containing the current theme and a function to retrieve CSS variables.
 */
function useThemeCssVars() {
  var _useTheme = (0, _ThemeContext.useTheme)(),
    theme = _useTheme.theme;
  var rootStyles = (0, _react.useRef)(getComputedStyle(document.documentElement));
  (0, _react.useEffect)(function () {
    rootStyles.current = getComputedStyle(document.documentElement);
  }, [theme]);

  /**
   * A function that takes a CSS variable name (without the '--' prefix) as a parameter and returns its value.
   *
   * @param {string} varName - The name of the CSS variable to retrieve.
   * @returns {string | null} The value of the CSS variable.
   */
  var getCssVar = (0, _react.useCallback)(function (varName) {
    var _rootStyles$current;
    var value = (_rootStyles$current = rootStyles.current) === null || _rootStyles$current === void 0 ? void 0 : _rootStyles$current.getPropertyValue("--".concat(varName)).trim();
    if (!value) console.warn("Missing value for CSS variable \"".concat(varName, "\""));
    return value || null;
  }, []);
  return {
    theme: theme,
    getCssVar: getCssVar
  };
}